/**
 * @file app 和 web 通信信号状态
 * @author liudy
 */
/**
 * 成功状态
 */
export const SUCCESS_STATUS  = {
    status: 1,
};

/**
 * 失败状态
 */
export const FAIL_STATUS  = {
    status: 0,
};
